import { css } from '@emotion/core'

export const continueButtonCss = css`
  width: 100%;
  margin-top: 1rem;
`
